import { Component, OnInit } from '@angular/core';
import { LocalStorage } from '../../shared/wrappers/LocalStorage';
import { GUARDS } from '../../shared/auth/Roles';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {
  userRole: string
  isJudiciary: boolean

  constructor(private localStorage: LocalStorage) { }

    async ngOnInit() {
      this.userRole = this.localStorage.retrieve('user').permission
      this.isJudiciary = GUARDS.JUDICIARY === this.userRole
    }
}



// WEBPACK FOOTER //
// ./src/app/views/dashboard/dashboard.component.ts